export enum SelectionModeEnum {
  None,
  Single,
  Multiple,
}
